var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"title"},[_vm._t("default"),(_vm.help)?_c('v-tooltip',{attrs:{"bottom":"","max-width":"500"}},[_c('v-icon',{staticClass:"ml-2",staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator","color":"info"},slot:"activator"},[_vm._v("info")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.help)}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }